export interface IDeliveryRecipient {
  id?: string // firestore id
  name: string
  postalCode: string
  prefecture: string
  address: string
  phone: string
  customerName: string
  updatedAt: Date|null
}

export class DeliveryRecipient implements IDeliveryRecipient {
  public readonly id: string
  public readonly name: string
  public readonly postalCode: string
  public readonly prefecture: string
  public readonly address: string
  public readonly phone: string
  public readonly customerName: string
  public readonly updatedAt: Date|null
  constructor({
    id = '',
    name = '',
    postalCode = '',
    prefecture = '',
    address = '',
    phone = '',
    customerName = '',
    updatedAt = null
  }: Partial<IDeliveryRecipient> = {}) {
    this.id = id || ''
    this.name = name
    this.postalCode = postalCode
    this.prefecture = prefecture
    this.address = address
    this.phone = phone
    this.customerName = customerName
    this.updatedAt = updatedAt
  }

  public toObject(): Omit<IDeliveryRecipient, 'id'> {
    return {
      name: this.name,
      postalCode: this.postalCode,
      prefecture: this.prefecture,
      address: this.address,
      phone: this.phone,
      customerName: this.customerName,
      updatedAt: this.updatedAt
    }
  }
}
